var render, staticRenderFns
import script from "./VMenu.vue?vue&type=script&lang=js&"
export * from "./VMenu.vue?vue&type=script&lang=js&"
import style0 from "./VMenu.vue?vue&type=style&index=0&id=31157a06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31157a06",
  null
  
)

export default component.exports